import { generatePageMetadata } from "@/lib/seo/metadata";
import { getStructuredData } from "@/lib/seo/structured-data";
import { ForAgenciesHero } from "@/features/landing/components/ForAgenciesHero";
import { ForAgenciesFeatureCards } from "@/features/landing/components/ForAgenciesFeatureCards";
import { Faq } from "@/shared/sections/Faq";
import { MarketingPage } from "@/shared/layout/MarketingPage";

const agenciesMetadata = generatePageMetadata({
  title: "For Agencies & Brands — Built for Media Buyers",
  description:
    "Plan and verify organic short-form reach across YouTube Shorts, TikTok, and Reels. Tier-1 creator supply, zkTLS-backed verification and reporting.",
  path: "/for-agencies",
});
const agenciesStructuredData = getStructuredData("for-agencies");

const AgenciesPage = () => {
  return (
    <MarketingPage metadata={agenciesMetadata} structuredData={agenciesStructuredData}>
      <ForAgenciesHero />
      <ForAgenciesFeatureCards />
      <Faq className="w-full" />
    </MarketingPage>
  );
};

export default AgenciesPage;
